<template>
    <div>
        <div class="topbanner">
            <img src="../assets/img/index/banner.png" alt="" class="beijing">
            <div class="neirong">
                <div class="logo">
                    <img src="../assets/img/index/logo.png" alt="">
                </div>
                <div class="biaoti">
                    <p class="big">文旅酒店</p>
                    <p class="big">让生活遇见美好</p>
                    <p class="small sxjianju">缔造全球旅客美好生活</p>
                    <p class="small">打造酒店行业领先品牌</p>
                </div>
                <div class="jianjie">
                    <div>
                        <img src="../assets/img/index/wenhua.png" alt="" class="wenhuaimg">
                        <p>中国旅游集团20强</p>
                    </div>
                    <div>
                        <img src="../assets/img/index/canyin.png" alt="" class="canyinimg">
                        <p>中国饭店集团30强</p>
                    </div>
                    <div class="sxjianju">
                        <img src="../assets/img/index/huiyuan.png" alt="" class="huiyuanimg">
                        <p>融合会员1亿<span>+</span></p>
                    </div>
                    <div class="sxjianju">
                        <img src="../assets/img/index/jiudian.png" alt="" class="jiudianimg">
                        <p>运营酒店300<span>+</span></p>
                    </div>
                </div>
                <div class="jieshao">
                    <p>
                        山东文旅酒店管理集团有限公司隶属于山东文旅集团有限公司，主营酒店业务，涉及餐饮等业态，拥有高端酒店及度假村、中端商旅酒店及公寓、度假酒店及民宿、设计师酒店、大众商旅酒店等12大品牌，遍及山东十六地市及百强县区，在全国多个省市都已布点。
                    </p>
                </div>
            </div>
        </div>
        <div class="bodyContent">
            <p class="fzbjtitle">
                <img src="../assets/img/index/biaotileft.png" alt="" class="left">
                <span>发展布局</span>
                <img src="../assets/img/index/biaotiright.png" alt="" class="right">
            </p>
            <div class="ditu">
                <img src="../assets/img/index/ditu.png" alt="">
                <div class="wzjieshaoone">
                    <p class="one">
                        发展布局
                    </p>
                    <p class="two">
                        Development Layou
                    </p>
                    <p class="three">
                        全国签约<span class="four">400</span>家<span class="jiahao">+</span>酒店
                    </p>
                    <p class="three">
                        分布<span class="four">40</span>个<span class="jiahao">+</span>城市
                    </p>
                </div>
            </div>
            <div class="wzjieshaotwo">
                <p class="title">国际合作品牌酒店1家</p>
                <p class="text sxjj">
                    菏泽颐庭华美达酒店。
                </p>
                <p class="title">中高端品牌酒店27家</p>
                <p class="text">
                    怡豪大饭店、颐庭酒店、佳悦酒店、北京泰山饭店、泉城大酒店、泰山·春天里度假酒店等。
                </p>
                <p style="margin:0;text-align:center;">
                    <img src="../assets/img/index/youshi.png" alt="" class="zhuanpan">
                </p>
            </div>
            <p class="fzbjtitle">
                <img src="../assets/img/index/biaotileft.png" alt="" class="left">
                <span>八大核心加盟优势</span>
                <img src="../assets/img/index/biaotiright.png" alt="" class="right">
            </p>
            <div class="jtys">
                <div class="left">全方位品牌宣传支持</div>
                <div class="right">加盟政策促利润提升</div>
            </div>
            <div class="jtys">
                <div class="left">专业化酒店设计团队</div>
                <div class="right">集团化高标准采购</div>
            </div>
            <div class="jtys">
                <div class="left">选址筹备省心省力</div>
                <div class="right">周期短/折旧率低</div>
            </div>
            <div class="jtys">
                <div class="left">全程管家式运营服务</div>
                <div class="right">专业运营管理十余年</div>
            </div>
        </div>
        <div class="jituanyoushi">
            <p class="title">集团优势</p>
            <p class="secondaryTitle">
                <span class="title1">多元化品牌</span>
                <span class="pinpai">
                    品牌<img src="../assets/img/index/yuandian.png" alt="">
                </span>
            </p>
            <p class="youshijieshao">
                <img src="../assets/img/index/duoyuan.png" alt="" class="duoyuan">
                <span>布局全国、强化品牌，丰富自身多元化品牌组合</span>
            </p>
            <p class="secondaryTitle">
                <span class="title1">收益化渠道</span>
                <span class="pinpai">
                    渠道<img src="../assets/img/index/yuandian.png" alt="">
                </span>
            </p>
            <p class="youshijieshao">
                <img src="../assets/img/index/shouyi.png" alt="" class="shouyi">
                <span>低投资加盟、高收益运营为业主创造更高产业价值</span>
            </p>
            <p class="secondaryTitle">
                <span class="title1">专业化运营</span>
                <span class="pinpai">
                    运营<img src="../assets/img/index/yuandian.png" alt="">
                </span>
            </p>
            <p class="youshijieshao">
                <img src="../assets/img/index/yunying.png" alt="" class="yunying">
                <span>提供酒店全方位运营，各阶段咨询指导及管理服务</span>
            </p>
            <p class="secondaryTitle">
                <span class="title1">数智化体系</span>
                <span class="pinpai">
                    体系<img src="../assets/img/index/yuandian.png" alt="">
                </span>
            </p>
            <p class="youshijieshao">
                <img src="../assets/img/index/shuzhi.png" alt="" class="shuzhi">
                <span>用技术推动酒店管理，引领行业数智化建设发展</span>
            </p>
        </div>
        <div class="jituanpinpai">
            <p class="fzbjtitle">
                <img src="../assets/img/index/biaotileft.png" alt="" class="left">
                <span>山东文旅酒店集团品牌</span>
                <img src="../assets/img/index/biaotiright.png" alt="" class="right">
            </p>
            <p class="gaoduan">
                <img src="../assets/img/index/hengxian.png" alt="" class="leftimg">
                <span>高端（全服务型）酒店</span>
                <img src="../assets/img/index/hengxian.png" alt="" class="rightimg">
            </p>
            <div class="jutijiudian">
                <div class="middlediv" @click="jump('怡豪')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/yihao.png" alt="">
                    </p>
                </div>
            </div>
            <div class="jutijiudian">
                <div class="leftdiv" @click="jump('颐庭')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/1.png" alt="">
                    </p>
                </div>
                <div class="rightdiv" @click="jump('佳悦')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/2.png" alt="">
                    </p>
                </div>
            </div>
            <p class="zhongduan">
                <img src="../assets/img/index/hengxian.png" alt="" class="leftimg">
                <span>中端&大众商旅酒店</span>
                <img src="../assets/img/index/hengxian.png" alt="" class="rightimg">
            </p>
            <div class="zdjiudian">
                <div class="leftdiv" @click="jump('佳悦精选')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/3.png" alt="" class="img3">
                    </p>
                </div>
                <div class="rightdiv" @click="jump('文度')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo" style="margin-top:10px">
                        <img src="../assets/img/index/4.png" alt="" class="img4">
                    </p>
                </div>
            </div>
            <div class="zdjiudian">
                <div class="leftdiv" @click="jump('精宿')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/5.png" alt="" class="img5">
                    </p>
                </div>
                <div class="rightdiv" @click="jump('和美')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/6.png" alt="" class="img6">
                    </p>
                </div>
            </div>
            <div class="zdjiudian">
                <div class="leftdiv" @click="jump('隽蘭')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/7.png" alt="" class="img7">
                    </p>
                </div>
                <div class="rightdiv" @click="jump('朵芭安')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo" style="margin-top:-5px;">
                        <img src="../assets/img/index/8.png" alt="" class="img8">
                    </p>
                </div>
            </div>
            <div class="zdjiudian">
                <div class="leftdiv" @click="jump('佳驿')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo" style="margin-top:10px">
                        <img src="../assets/img/index/9.png" alt="" class="img9">
                    </p>
                </div>
                <div class="rightdiv" @click="jump('轻居')">
                    <p class="jinru">
                        <img src="../assets/img/index/jinru.png" alt="">
                    </p>
                    <p class="jiudianlogo">
                        <img src="../assets/img/index/10.png" alt="" class="img10">
                    </p>
                </div>
            </div>
        </div>
        <div class="footer">
            <div class="joinIn">
                <div class="jtjm">
                    <div class="lefterweima">
                        <img src="../assets/img/index/erweima.png" alt="">
                        <p>山东文旅酒店集团</p>
                    </div>
                    <div class="rightphone">
                        <img src="../assets/img/index/phone.png" alt="">
                        <p class="rexian">加盟热线</p>
                        <p class="dianhua">135-1531-0058</p>
                    </div>
                </div>
            </div>
            <div class="bottomPicture">
                <img src="../assets/img/index/dibulogo.png" alt="">
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    methods: {
        // 跳转
        jump(val) {
            if (val == '颐庭') {
                this.$router.push({ path: "/Yiting" })
            } else if (val == '佳悦') {
                this.$router.push({ path: "/Jiayue" })
            } else if (val == '怡豪') {
                this.$router.push({ path: "/Yihao" })
            } else if (val == '佳悦精选') {
                this.$router.push({ path: "/Jyjingxuan" })
            } else if (val == '文度') {
                this.$router.push({ path: "/Wendu" })
            } else if (val == '精宿') {
                this.$router.push({ path: "/Jingsu" })
            } else if (val == '和美') {
                this.$router.push({ path: "/Hemei" })
            } else if (val == '隽蘭') {
                this.$router.push({ path: "/Junlan" })
            } else if (val == '朵芭安') {
                this.$router.push({ path: "/Duobaan" })
            } else if (val == '佳驿') {
                this.$router.push({ path: "/Jiayi" })
            } else if (val == '轻居') {
                this.$router.push({ path: "/Qingju" })
            }
        }
    }
}
</script>

<style lang="less" scoped>
.topbanner {
    width: 100%;
    height: 100vh;
    position: relative;

    .beijing {
        width: 100%;
        height: 100%;
        position: absolute;
    }

    .neirong {
        position: relative;
        width: 100%;
        height: auto;

        .logo {
            width: 100%;
            height: auto;
            text-align: center;

            img {
                margin-top: 47px;
                width: 35%;
            }
        }

        .biaoti {
            margin-top: 80px;
            margin-left: 43px;

            p {
                margin: 0;
            }

            .big {
                font-size: 83px;
                letter-spacing: 0px;
                color: #ffffff;
                font-family: 'PRC';
                text-shadow: -1px -1px 0px rgba(0, 0, 0, 0.36), -2px -2px 0px rgba(0, 0, 0, 0.36),
            }

            .sxjianju {
                margin-top: 40px;
            }

            .small {
                font-size: 32px;
                line-height: 58px;
                letter-spacing: 0px;
                color: #ffffff;
                font-family: 'pfct';
                text-shadow: -1px -1px 0px rgba(0, 0, 0, 0.36), -2px -2px 0px rgba(0, 0, 0, 0.36),
            }
        }

        .jianjie {
            margin: 0 86px;
            margin-top: 110px;

            div {
                width: 50%;
                text-align: center;
                display: inline-block;

                .wenhuaimg {
                    width: 62px;
                    height: 58px;
                }

                .canyinimg {
                    width: 53px;
                    height: 51px;
                }

                .huiyuanimg {
                    width: 67px;
                    height: 53px;
                }

                .jiudianimg {
                    width: 60px;
                    height: 56px;
                }

                p {
                    font-family: 'pfzd';
                    font-size: 22px;
                    letter-spacing: 0px;
                    color: #ffffff;
                }
            }

            .sxjianju {
                margin-top: 74px;

                p {
                    span {
                        position: relative;
                        top: -10px;
                        left: 2px;
                    }
                }
            }
        }

        .jieshao {
            margin: 90px 39px 0;

            p {
                font-family: 'pfzd';
                font-size: 24px;
                letter-spacing: 0px;
                text-indent: 2em;
                color: #ffffff;
                text-shadow: -1px -1px 0px rgba(0, 0, 0, 0.36), -2px -2px 0px rgba(0, 0, 0, 0.36),
            }
        }
    }
}

.bodyContent {
    margin: 0 30px;

    .fzbjtitle {
        text-align: center;
        padding-top: 27px;

        img {
            vertical-align: middle;
        }

        .left {
            width: 38px;
            height: 38px;
            margin-right: 42px;
            vertical-align: text-bottom;
        }

        .right {
            width: 22px;
            height: 22px;
            margin-left: 27px;
        }

        span {
            vertical-align: middle;
            font-size: 36px;
            font-family: 'pfct';
            letter-spacing: 0px;
            color: #004569;
        }
    }

    .ditu {
        width: 100%;
        height: 772px;
        position: relative;

        img {
            width: 100%;
            position: absolute;
        }

        .wzjieshaoone {
            position: absolute;
            bottom: 0;

            p {
                margin: 0;
            }

            .one {
                font-family: 'pfct';
                font-size: 35px;
                letter-spacing: 3px;
                color: #0d2f56;
            }

            .two {
                font-family: 'pfct';
                font-size: 19px;
                letter-spacing: 0px;
                color: #a1a1a1;
                margin-bottom: 18px;
            }

            .three {
                font-family: SourceHanSansCN-Medium;
                font-size: 23px;
                line-height: 45px;
                letter-spacing: 2px;
                color: #180000;
            }

            .four {
                font-family: 'PRC';
                font-size: 33px;
                letter-spacing: 0px;
                color: #0d2f56;
            }

            .jiahao {
                font-family: 'PRC';
                font-size: 23px;
                letter-spacing: 2px;
                color: #0d2f56;
            }
        }
    }

    .wzjieshaotwo {
        margin-top: 58px;

        p {
            margin: 0;
        }

        .title {
            font-family: 'pfct';
            font-size: 23px;
            letter-spacing: 2px;
            color: #180000;
        }

        .sxjj {
            margin-bottom: 33px;
        }

        .text {
            font-family: 'pfzd';
            font-size: 20px;
            letter-spacing: 2px;
            color: #180000;
            padding-right: 78px;
        }

        .zhuanpan {
            width: 516px;
            height: 516px;
            margin: 0 auto;
            margin-top: 56px;
        }
    }

    .jtys {
        margin: 0 40px;
        margin-top: 36px;
        height: 130px;

        div {
            width: 80%;
            height: 69px;
            line-height: 69px;
            border-radius: 16px;
            text-align: center;
            color: #d9b57b;
            font-size: 26px;
            font-family: 'pfzd';
        }

        .left {
            float: left;
            background-color: #004569;
        }

        .right {
            float: right;
            border: 2px solid #004569;
            margin-top: -10px;
        }
    }
}

.jituanyoushi {
    margin-top: 42px;
    width: 100%;
    height: 880px;
    background-image: url(../assets/img/index/jituanyoushi.png);
    background-repeat: no-repeat;
    background-size: 100% 100%;

    p {
        margin: 0;
    }

    .title {
        text-align: center;
        font-family: 'pfct';
        font-size: 44px;
        letter-spacing: 0px;
        color: #ffffff;
        padding-top: 52px;
        margin-bottom: 60px;
    }

    .secondaryTitle {
        margin-left: 50px;

        .title1 {
            display: inline-block;
            vertical-align: middle;
            font-family: 'pfzd';
            font-size: 32px;
            letter-spacing: 0px;
            color: #d9b57b;
            padding-left: 16px;
            border-left: 6px solid #d9b57b;
            margin-right: 16px;
        }

        .pinpai {
            display: inline-block;
            width: 86px;
            height: 28px;
            background-image: url(../assets/img/index/pinpai.png);
            background-repeat: no-repeat;
            background-size: 100% 100%;
            vertical-align: middle;
            text-align: center;
            font-family: 'pfzd';
            font-size: 22px;
            letter-spacing: 0px;
            color: #ffffff;


            img {
                vertical-align: middle;
                margin-left: 5px;
                margin-top: -5px;
                width: 6px;
                height: 6px;
            }
        }
    }

    .youshijieshao {
        margin-left: 72px;
        margin-top: 39px;
        margin-bottom: 36px;

        img {
            vertical-align: middle;
            margin-right: 22px;
        }

        .duoyuan {
            width: 51px;
            height: 53px;
        }

        .shouyi {
            width: 56px;
            height: 55px;
        }

        .yunying {
            width: 48px;
            height: 50px;
        }

        .shuzhi {
            width: 52px;
            height: 55px;
        }

        span {
            vertical-align: middle;
            font-family: 'pfzd';
            font-size: 26px;
            letter-spacing: 0px;
            color: #ffffff;
        }
    }
}

.jituanpinpai {

    .fzbjtitle {
        text-align: center;
        padding-top: 27px;

        img {
            vertical-align: middle;
        }

        .left {
            width: 38px;
            height: 38px;
            margin-right: 42px;
            vertical-align: text-bottom;
        }

        .right {
            width: 22px;
            height: 22px;
            margin-left: 27px;
        }

        span {
            vertical-align: middle;
            font-size: 36px;
            font-family: 'pfct';
            letter-spacing: 0px;
            color: #004569;
        }
    }

    .gaoduan {
        margin: 0;
        margin-top: 43px;
        text-align: center;

        img {
            width: 15%;
            vertical-align: middle;
        }

        .leftimg {
            margin-right: 29px;
        }

        .rightimg {
            margin-left: 29px;
        }

        span {
            vertical-align: middle;
            font-family: 'pfzd';
            font-size: 32px;
            letter-spacing: 0px;
            color: #4b4b4b;
        }
    }

    .jutijiudian {
        margin: 0 30px;
        margin-top: 57px;
        text-align: center;

        div {
            width: 270px;
            height: 270px;
            display: inline-block;
            vertical-align: middle;
            background-color: #ffffff;
            box-shadow: 0px 4px 16px 0px rgba(152, 152, 152, 0.24);
            border-radius: 10px;
            border: solid 1px #989898;

            p {
                margin: 0;
            }

            .jinru {
                padding: 24px 26px;
                text-align: right;

                img {
                    width: 28px;
                    height: 30px;
                }
            }
        }
        .middlediv {
            justify-items: center;

            .jiudianlogo {
                text-align: center;

                img {
                    width: 155px;
                    height: 100px;
                }
            }
        }
        .leftdiv {
            margin-right: 9%;

            .jiudianlogo {
                text-align: center;

                img {
                    width: 155px;
                    height: 100px;
                }
            }
        }

        .rightdiv {
            .jiudianlogo {
                text-align: center;

                img {
                    width: 155px;
                    height: 89px;
                }
            }
        }
    }

    .zhongduan {
        margin: 0;
        margin-top: 43px;
        text-align: center;

        img {
            width: 19%;
            vertical-align: middle;
        }

        .leftimg {
            margin-right: 29px;
        }

        .rightimg {
            margin-left: 29px;
        }

        span {
            vertical-align: middle;
            font-family: 'pfzd';
            font-size: 32px;
            letter-spacing: 0px;
            color: #4b4b4b;
        }
    }

    .zdjiudian {
        margin: 0 30px;
        margin-top: 60px;
        text-align: center;

        div {
            width: 270px;
            height: 270px;
            display: inline-block;
            vertical-align: middle;
            background-color: #ffffff;
            box-shadow: 0px 4px 16px 0px rgba(152, 152, 152, 0.24);
            border-radius: 10px;
            border: solid 1px #989898;

            p {
                margin: 0;
            }

            .jinru {
                padding: 24px 26px;
                text-align: right;

                img {
                    width: 28px;
                    height: 30px;
                }
            }
        }

        .leftdiv {
            margin-right: 9%;

            .jiudianlogo {
                text-align: center;

                .img3 {
                    width: 177px;
                    height: 92px;
                }

                .img5 {
                    width: 113px;
                    height: 118px;
                }

                .img7 {
                    width: 107px;
                    height: 110px;
                }

                .img9 {
                    width: 159px;
                    height: 75px;
                }
            }
        }

        .rightdiv {
            .jiudianlogo {
                text-align: center;

                .img4 {
                    width: 186px;
                    height: 55px;
                }

                .img6 {
                    width: 158px;
                    height: 90px;
                }

                .img8 {
                    width: 144px;
                    height: 129px;
                }

                .img10 {
                    width: 146px;
                    height: 103px;
                }
            }
        }
    }
}

.footer {
    width: 100%;
    margin-top: 32px;

    .joinIn {
        width: 100%;
        height: 363px;
        background-color: #004569;

        .jtjm {
            padding: 52px 55px 52px 69px;

            div {
                display: inline-block;
                vertical-align: middle;
                text-align: center;

                p {
                    margin: 0;
                }
            }

            .lefterweima {
                width: 49%;
                border-right: 1px solid #f9f9f9;

                img {
                    width: 204px;
                    height: 204px;
                }

                p {
                    font-family: 'pfzd';
                    font-size: 24px;
                    letter-spacing: 0px;
                    color: #ffffff;
                    margin-top: 20px;
                }
            }

            .rightphone {
                width: 50%;

                img {
                    width: 129px;
                    height: 129px;
                }

                .rexian {
                    font-family: 'pfzd';
                    font-size: 32px;
                    letter-spacing: 0px;
                    color: #ffffff;
                    margin: 27px 0;
                }

                .dianhua {
                    font-family: 'pfct';
                    font-size: 32px;
                    letter-spacing: 0px;
                    color: #ffffff;
                }
            }
        }
    }

    .bottomPicture {
        padding: 30px 123px;

        img {
            width: 100%;
        }
    }
}
</style>
